import { useEffect, useRef, useState } from "react";
import ndt from "@/assets/ndt.jpg";

const STATS = [
  { value: 10, suffix: "+", label: "Certified Inspectors", sub: "API, ASNT, LEEA, IRATA" },
  { value: 20, suffix: " yrs", label: "Offshore Experience", sub: "Across Gulf and global basins" },
  { value: 99.8, suffix: "%", label: "Safety Record", sub: "Zero-harm operating culture" },
  { value: 100, suffix: "%", label: "Compliance Driven", sub: "API, ISO, DNV, ASME standards" },
  {
    value: 40,
    suffix: "+",
    label: "International Standards",
    sub: "Codes and recommended practice",
  },
];

function Counter({ to, suffix }: { to: number; suffix: string }) {
  const [val, setVal] = useState(0);
  const ref = useRef<HTMLSpanElement>(null);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          const duration = 1800;
          const start = performance.now();
          const step = (t: number) => {
            const p = Math.min(1, (t - start) / duration);
            const eased = 1 - Math.pow(1 - p, 3);
            setVal(to * eased);
            if (p < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        }
      },
      { threshold: 0.3 },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [to]);

  const display = Number.isInteger(to) ? Math.round(val).toString() : val.toFixed(1);
  return (
    <span ref={ref}>
      {display}
      {suffix}
    </span>
  );
}

export function Stats() {
  return (
    <section className="relative section-y overflow-hidden bg-ocean text-white">
      <img
        src={ndt}
        alt=""
        aria-hidden
        width={1280}
        height={800}
        loading="lazy"
        className="absolute inset-0 -z-10 h-full w-full object-cover opacity-10"
      />
      <div className="absolute inset-0 -z-10 bg-gradient-to-r from-navy-deep to-ocean/90" />
      <div className="container-x">
        <div className="max-w-2xl">
          <span className="eyebrow">Why Solid Proof Energy</span>
          <h2 className="mt-4 text-3xl font-black tracking-tight text-white sm:text-4xl lg:text-5xl">
            Crafted for operators who refuse shortcuts, combining relentless accuracy with quality that stands the test of time.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-white/15 bg-white/10 md:grid-cols-3 lg:grid-cols-5">
          {STATS.map((s) => (
            <div key={s.label} className="bg-navy-deep/60 p-7 backdrop-blur">
              <div className="text-4xl font-black tracking-tight text-orange sm:text-5xl">
                <Counter to={s.value} suffix={s.suffix} />
              </div>
              <div className="mt-3 text-sm font-bold text-white">{s.label}</div>
              <div className="mt-1 text-xs text-white/60">{s.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
